import * as actionTypes from "~/store/action_types";

const recurringTasks = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FILES_AND_ATTACHMENTS_SUCCESS:
    case actionTypes.FETCH_RECURRING_TASKS_SUCCESS:
    case actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS:
    case actionTypes.ANGULAR_INITIALIZE_TASKS:
      if (action.response && action.response.entities && action.response.entities.recurring_tasks) {
        return { ...state, ...action.response.entities.recurring_tasks };
      }
      return state;
    case actionTypes.MOVE_RECURRING_TASK_TO_TRASH_SUCCESS: {
      const { taskId = 0, response = {} } = action;
      const { single = {} } = response;
      const { id = 0 } = single;
      if (taskId && id) {
        return { ...state, [taskId]: single };
      }
      return state;
    }
    case actionTypes.ADD_RECURRING_TASK_SUCCESS:
    case actionTypes.FETCH_RECURRING_TASK_SUCCESS:
    case actionTypes.EDIT_RECURRING_TASK_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { recurring_tasks = {} } = entities;
      const { single: recurringTaskId } = result;

      if (recurringTaskId) {
        return {
          ...state,
          [recurringTaskId]: recurring_tasks[recurringTaskId],
        };
      }

      return state;
    }
    case actionTypes.RECURRING_TASK_MOVED_TO_TRASH_FROM_EVENT_STREAM:
    case actionTypes.UPDATE_RECURRING_TASK_FROM_EVENT_STREAM:
    case actionTypes.RECURRING_TASK_RESTORED_FROM_TRASH_FROM_EVENT_STREAM:
    case actionTypes.ADD_RECURRING_TASK_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result: recurringTaskId } = response;
      const { recurring_tasks = {} } = entities;

      if (recurringTaskId) {
        return {
          ...state,
          [recurringTaskId]: recurring_tasks[recurringTaskId],
        };
      }

      return state;
    }

    case actionTypes.MOVE_USER_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.USER_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS: {
      const { response = {} } = action;
      const { result: id } = response;
      const recurringTasks = state;
      for (const key in recurringTasks) {
        if (recurringTasks[key].assignee_id === id) {
          recurringTasks[key].assignee_id = 0;
        }
        if (recurringTasks[key].subtasks && recurringTasks[key].subtasks?.length > 0) {
          recurringTasks[key].subtasks = recurringTasks[key].subtasks.map((subtask) => {
            if (subtask.assignee_id === id) {
              return { ...subtask, assignee_id: 0 };
            }
            return subtask;
          });
        }
      }
      return recurringTasks;
    }

    case actionTypes.PROJECT_TEMPLATE_APPLY_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { recurring_tasks } = entities;

      const newState = { ...state, ...recurring_tasks };
      return newState;
    }

    default:
      return state;
  }
};

export default recurringTasks;
